import StarIcon from "@/components/icons/star-icon"
import { langStore } from "../../../stores/lang-store"

const bundle = { ko: "즐겨찾기", en: "Favorites", es: "Favoritos" }

const FavoriteButton = ({ onClick, active }) => {
  const { lang } = langStore()

  return (
    <button
      onClick={onClick}
      className={`px-3 py-2 rounded-full text-xs font-bold border transition-all 
        flex gap-1.5 items-center cursor-pointer
        ${active ? "bg-yellow-400 border-yellow-400 text-white shadow-sm" : "bg-white border-slate-200 text-slate-500 hover:border-slate-300"}`}
    >
      <StarIcon className="w-3.5 mb-0.5" />
      {bundle[lang]}
    </button>
  )
}

export default FavoriteButton
